<template>
  <div :class="theme" class="icon-wrapper">
    <span class="material-icons-outlined icon">
      {{ icon }}
    </span>

    <span v-if="text" class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    theme: {
      type: String,
    },
    text: {
      type: String,
    },
  },

  methods: {},

  mounted() {},
};
</script>
<style scoped lang="scss">
.icon-wrapper {
  border-radius: 12px;
  display: flex;
  align-items: center;
  max-width: fit-content;
  padding: 12px;

  @media (max-width: 650px) {
    padding: 8px;
  }
  &.purple {
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  }
  &.orange {
    background: linear-gradient(135deg, #f97316, #dc2626);
  }
  &.green {
    background: linear-gradient(135deg, #10b981, #059669);
  }
  &.black {
    background: #1e293b;
    color: #cbd5e1;
  }
}
.icon {
  font-size: 24px;
  color: white;

  @media (max-width: 650px) {
    font-size: 18px;
  }
}
</style>
